import Modal from "../Modal/modal";
import { useState } from "react";
import { API_URL } from "../constants";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaKey } from "react-icons/fa";
import Toast from "../DetailsCompteur/Toast";

export default function ForgotPassword(props) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState({ type: '', message: '' });
  const navigate = useNavigate();

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast({ type: '', message: '' }), 3000);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email) return;

    setSubmitting(true);
    try {
      const response = await axios.put(`${API_URL}/user/resetpassword`, {
        email: email,
      }, {
        headers: {
          mode: "cors",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      showToast('success', response.data.message || 'Un nouveau mot de passe vous a été envoyé.');
      setEmail("");
    } catch (error) {
      if (error.response?.status === 401) {
        alert("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
        localStorage.clear();
        navigate("/login");
        return;
      }
      const message = error.response?.data?.error || "Adresse e-mail introuvable.";
      showToast('error', message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isShowing={props.isShowing} hide={props.hide} title="Mot de passe oublié">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-400 to-amber-400 flex items-center justify-center shrink-0">
          <FaKey className="text-white text-sm" />
        </div>
        <p className="text-sm text-gray-500">
          Recevez un nouveau mot de passe par e-mail.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="bg-gray-50 rounded-xl p-5">
          <label className="block text-sm font-medium text-gray-600 mb-2">
            Adresse e-mail
          </label>
          <input
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="vous@exemple.com"
            className="w-full border border-gray-300 rounded-lg px-4 py-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
          />
        </div>

        <button
          type="submit"
          disabled={submitting || !email}
          className="w-full bg-gradient-to-r from-orange-500 to-amber-500 text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium disabled:opacity-50"
        >
          {submitting ? 'Envoi...' : 'Réinitialiser le mot de passe'}
        </button>
      </form>

      <Toast type={toast.type} message={toast.message} />
    </Modal>
  );
}